function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import cx from 'classnames';
import StringHash from 'string-hash';
import { ReactSVG } from 'react-svg';
import { BackgroundImage } from '../../utils';

var Hero = function Hero(_ref) {
  var backgroundImage = _ref.backgroundImage,
      backgroundImagePosition = _ref.backgroundImagePosition,
      _ref$half = _ref.half,
      half = _ref$half === void 0 ? false : _ref$half,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? false : _ref$header,
      type = _ref.type,
      _ref$jojo = _ref.jojo,
      jojo = _ref$jojo === void 0 ? false : _ref$jojo,
      illustration = _ref.illustration,
      illustrationClass = _ref.illustrationClass,
      video = _ref.video,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["backgroundImage", "backgroundImagePosition", "half", "header", "type", "jojo", "illustration", "illustrationClass", "video", "children"]);

  var hash = backgroundImage && StringHash(backgroundImage);
  var classes = cx(type ? "hero-" + type : 'hero', backgroundImagePosition && backgroundImagePosition, header && 'is-header', half && 'half', hash && "rbiHandler-" + hash, video && 'has-video');
  if (video && illustration) console.warn('Do not use a video and illustration in the same hero.');

  var Illustration = function Illustration() {
    if (!illustration) return /*#__PURE__*/React.createElement(React.Fragment, null);
    var illustrationClasses = cx('illustration', illustrationClass);
    var Tag = illustration.match(/.svg$/g) ? ReactSVG : 'img';
    return /*#__PURE__*/React.createElement("div", {
      className: illustrationClasses
    }, /*#__PURE__*/React.createElement(Tag, {
      src: illustration,
      alt: ""
    }));
  };

  var Video = function Video() {
    if (!video) return /*#__PURE__*/React.createElement(React.Fragment, null); // eslint-disable-next-line global-require

    var _require = require('../VideoPlayer'),
        VideoPlayer = _require.VideoPlayer;

    return /*#__PURE__*/React.createElement(VideoPlayer, {
      url: video.url,
      autoPlay: video.autoPlay
    });
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, rest), BackgroundImage(backgroundImage, hash), /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, jojo && /*#__PURE__*/React.createElement("div", {
    className: "jojo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  })), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, children)), /*#__PURE__*/React.createElement(Illustration, null), /*#__PURE__*/React.createElement(Video, null)));
};

Hero.displayName = 'Hero';
var HeroDoc;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  HeroDoc = require('./doc').doc(Hero);
}

var HeroWrapper = HeroDoc || Hero;
export { HeroWrapper as Hero };